import { Card } from "antd";
import { AlunoSelect } from "../Manager/Pessoa/Aluno/AlunoSelect";

interface IAlunosScreenProps {
    /**
     * @default true
     */
    permiteAlterarAluno?:boolean;
    /** @default false */
    permiteCadastrarNovoAluno?:boolean;
}
export default function AlunosScreen ({
    permiteAlterarAluno,
    permiteCadastrarNovoAluno
}:IAlunosScreenProps) {
    permiteAlterarAluno = permiteAlterarAluno ?? true;
    permiteCadastrarNovoAluno = permiteCadastrarNovoAluno ?? false;

    return <Card>
        <AlunoSelect 
            permiteAlterarAluno={permiteAlterarAluno} 
            permiteCadastrarNovoAluno={permiteCadastrarNovoAluno} 
            label={"Selecione um aluno"}
        />
    </Card>;
}